export default from './PriceTargetQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/PriceTargetQuestion/index.js